export const PENDING_REFRESH_KEY = "vouch-pick-pending-refresh"
export const SELECTIONS_KEY = "vouch-pick-selections"

const PICK_PATH_PATTERN = /\/volunteer_campaign_sessions\/([^/]+)\/pick/

export function sessionTokenFromPath(pathname = window.location.pathname) {
  const match = pathname.match(PICK_PATH_PATTERN)
  return match?.[1] ?? null
}

function pickComposeForms() {
  return Array.from(document.querySelectorAll('form[data-controller~="pick-compose"]'))
}

function readStoredSelections() {
  const raw = sessionStorage.getItem(SELECTIONS_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw)
  } catch (_error) {
    return null
  }
}

export function saveAllFormSelections() {
  const sessionToken = sessionTokenFromPath()
  if (!sessionToken) return

  const groups = {}

  pickComposeForms().forEach((form) => {
    const groupId = form.querySelector('input[name="group_id"]')?.value
    if (!groupId) return

    groups[groupId] = Array.from(
      form.querySelectorAll('input[name="emails[]"]:checked')
    ).map((checkbox) => checkbox.value)
  })

  sessionStorage.setItem(
    SELECTIONS_KEY,
    JSON.stringify({ sessionToken, groups })
  )
}

export function restoreAllFormSelections() {
  const sessionToken = sessionTokenFromPath()
  if (!sessionToken) return false

  const stored = readStoredSelections()
  if (!stored) return false

  if (stored.sessionToken !== sessionToken) {
    clearStoredSelections()
    return false
  }

  pickComposeForms().forEach((form) => {
    const groupId = form.querySelector('input[name="group_id"]')?.value
    if (!groupId) return

    const checkedEmails = stored.groups?.[groupId]
    if (!checkedEmails) return

    const checkedSet = new Set(checkedEmails)
    form.querySelectorAll('input[name="emails[]"]').forEach((checkbox) => {
      checkbox.checked = checkedSet.has(checkbox.value)
    })
  })

  return true
}

export function clearStoredSelections() {
  sessionStorage.removeItem(SELECTIONS_KEY)
}
